export default __webpack_public_path__ + "static/media/male.74c6caff.jpg";